// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  UploadStatus,
} from "./types";

export default {
  progressId: __t.u64(),
  get status() {
    return UploadStatus;
  },
  filesUploaded: __t.u32(),
  bytesUploaded: __t.u64(),
  currentFile: __t.option(__t.string()),
};
